import ApiService from "../api";

export default class SaldoProjetadoBpService extends ApiService {
    constructor() {
        super('/api/solicitacoes/rateio-saldo-projetado')
    }
    consultar(baseBpId, { ano, mes } = {}) {
        const params = new URLSearchParams();
        if (ano) params.set("ano", ano);
        if (mes) params.set("mes", mes);
        const query = params.toString();
        return this.get(`/${encodeURIComponent(baseBpId)}${query ? `?${query}` : ""}`);
    }
}
